module.exports = __webpack_public_path__ + "media/logos/logo_ENSECH_letras-e766955d.png";